import { FC } from 'react';
import { emptyObject } from '@constants/empty';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import {
  fetchSuccessStoryForGoal,
  fetchSuccessStoryPageData
} from '@api/fetchers/success-story';
import NewGoalLayout from '@layout/NewGoalLayout/NewGoalLayout';
import { SUCCESS_STORY } from '@cont/NewPreSubscribed/constants';
import NewSuccessStory from '@cont/NewSuccessStory/NewSuccessStory';
import fetchPageMetaInfo from '@api/fetchers/pageMetaInfo';
import { fetchGoalInfo } from '@api/fetchers/goal';
import { fetchUserProfileInfo } from '@api/fetchers/store';
import {
  ISuccessStoryBlock,
  SuccessStoryBlockType
} from '../../../../../types/success-story';
import PlusHomePage from '../../[goalUID]';

interface ISuccessStoryProps {
  cmsData?: {
    heroBanner: {
      webImage: string;
      mwebImage: string;
      videoUrl: string;
    };
    examResult: {
      header: string;
      results: {
        title: string;
        subTitle: string;
        description: string;
        webImage: string;
        mwebImage: string;
      }[];
    };
  };
  reviewsBlock?: ISuccessStoryBlock;
  achievementBlock?: ISuccessStoryBlock;
}

const SuccessStory: FC<ISuccessStoryProps> = ({
  cmsData,
  reviewsBlock,
  achievementBlock
}) => {
  return (
    <NewSuccessStory
      cmsData={cmsData}
      reviewsBlock={reviewsBlock}
      achievementBlock={achievementBlock}
    />
  );
};

// @ts-ignore
SuccessStory.pageInfo = {
  name: SUCCESS_STORY,
  layoutOptions: {
    hideLearnerMinutes: true,
    disableDarkMode: true
  },
  isMWebSupported: true
};

export const getStaticProps = async ({ params, preview }) => {
  const { goalUID: routeGoalUid } = params || emptyObject;
  const promises = [];

  promises.push(
    fetchSuccessStoryForGoal(routeGoalUid)
      .then((res) => res)
      .catch(() => null)
  );
  promises.push(fetchSuccessStoryPageData(routeGoalUid));
  promises.push(
    fetchPageMetaInfo(PlusHomePage.pageInfo.name, routeGoalUid, preview)
  );
  promises.push(fetchUserProfileInfo(routeGoalUid));
  promises.push(fetchGoalInfo(routeGoalUid));

  const [cmsData, pageData, metaInfo = {}, userProfile, goalInfo] =
    await Promise.all(promises);

  const reviewsBlock =
    pageData?.find((block) => block.type === SuccessStoryBlockType.REVIEWS) ||
    emptyObject;
  const achievementBlock =
    pageData?.find(
      (block) => block.type === SuccessStoryBlockType.ACHIEVEMENT_STORY_V2
    ) || emptyObject;

  return {
    props: {
      cmsData,
      pageData,
      reviewsBlock,
      achievementBlock,
      pageMetaInfo: { ...metaInfo, showStoreTab: userProfile?.showStoreTab }
    },
    revalidate: 10 * 60
  };
};

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking'
  };
};

// @ts-ignore
SuccessStory.Layout = NewGoalLayout;
// @ts-ignore
SuccessStory.Layout.displayName = 'SuccessStory';

export default SuccessStory;
// @ts-ignore
SuccessStory.Wrapper = PageReduxProvider;
